import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'app-retirement-suite',
  templateUrl: './retirement-suite.component.html',
  styleUrls: ['./retirement-suite.component.css']
})
export class RetirementSuiteComponent implements OnInit {
  error;
  welcomeHVSApplications = "";
  private navCards = [];

  constructor(private globalService: GlobalService, private loadingService: LoadingService) { }

  ngOnInit() {
    this.loadingService.isLoading(true);

    this.globalService.GetRetirementSuite(Number(localStorage.getItem('orgID')))
      .subscribe(
        apps => { 
          console.log('retirement suite apps', apps);

          for(let app of apps){
            this.navCards.push({ title: app.AppName, 
              description: app.AppDesc, 
              icon: '', 
              color: app.Color, 
              iconColor: '', 
              image: app.DisplayImage,
              fromApplicationStore: true,
              //TODO: need to fix this - right now this is handled in nav-card.componenet.ts and applications-link.componenet.ts
              //nav-card should be changed to pass a url and use that url if one is passed
              applicationLink: app.DisplayCode,

              //iframes do not need this button
              //actionButton: (app.AppType > 1)
            }
          );

            //console.log('app displaycode', app.DisplayCode);            
        }

        this.loadingService.isLoading(false);
      },
      error => this.error = <any>error);
  }

}
